<lib-form-field-container
    [kind]="FormContainerKind.Text"
    [isOptional]="isOptional">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <!-- eslint-disable-next-line -->
        <div class="default-content">••••••</div>
    </ng-container>

    <ng-container suffixIcon>
        <lib-icon-button
            class="cursor-pointer"
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [disabled]="isDisabled"
            [icon]="suffixViewIcon"
            (clicked)="ToggleView()"></lib-icon-button>
    </ng-container>

    <input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        [attr.autocorrect]="autocorrect ? 'on' : 'off'"
        [autocomplete]="autocorrect ? 'on' : 'off'"
        [spellcheck]="autocorrect"
        [type]="inputType"
        [placeholder]="placeholderText"
        [attr.data-sb-qa]="qaTag"
        (blur)="OnBlur()"
        (change)="$event.stopPropagation()" />
</lib-form-field-container>
